var React = require('react');

function LsFeeIconInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"32","height":"32","fill":"#1F1747","key":0}),React.createElement("path",{"d":"M7.36147 4.84375L4.40625 19.5625H10.969L12.4466 12.2031L13.9375 4.84375H7.36147Z","fill":"#6097CD","key":1}),React.createElement("path",{"d":"M10.9795 19.5625L9.46875 27.0938L27.625 19.5625H10.9795Z","fill":"#6097CD","key":2})]);
}

LsFeeIconInline.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = LsFeeIconInline;

LsFeeIconInline.default = LsFeeIconInline;
